export const PARTI_LIST_REQUEST = 'PARTI_LIST_REQUEST'
export const PARTI_LIST_SUCCESS = 'PARTI_LIST_SUCCESS'
export const PARTI_LIST_FAIL = 'PARTI_LIST_FAIL'
export const PARTI_LIST_RESET = 'PARTI_LIST_RESET'

export const ASSIGN_PARTI_REQUEST = 'ASSIGN_PARTI_REQUEST'
export const ASSIGN_PARTI_SUCCESS = 'ASSIGN_PARTI_SUCCESS'
export const ASSIGN_PARTI_FAIL = 'ASSIGN_PARTI_FAIL'
export const ASSIGN_PARTI_RESET = 'ASSIGN_PARTI_RESET'

export const DOWNLOAD_TEXT_RESP_REQUEST = 'DOWNLOAD_TEXT_RESP_REQUEST'
export const DOWNLOAD_TEXT_RESP_SUCCESS = 'DOWNLOAD_TEXT_RESP_SUCCESS'
export const DOWNLOAD_TEXT_RESP_FAIL = 'DOWNLOAD_TEXT_RESP_FAIL'
export const DOWNLOAD_TEXT_RESP_RESET = 'DOWNLOAD_TEXT_RESP_RESET'

export const DOWNLOAD_RESP_TIME_REQUEST = 'DOWNLOAD_RESP_TIME_REQUEST'
export const DOWNLOAD_RESP_TIME_SUCCESS = 'DOWNLOAD_RESP_TIME_SUCCESS'
export const DOWNLOAD_RESP_TIME_FAIL = 'DOWNLOAD_RESP_TIME_FAIL'
export const DOWNLOAD_RESP_TIME_RESET = 'DOWNLOAD_RESP_TIME_RESET'

export const CREATE_PARTI_REQUEST = 'CREATE_PARTI_REQUEST'
export const CREATE_PARTI_SUCCESS = 'CREATE_PARTI_SUCCESS'
export const CREATE_PARTI_FAIL = 'CREATE_PARTI_FAIL'
export const CREATE_PARTI_RESET = 'CREATE_PARTI_RESET'

// for public OAuth callback handler
export const UPDATE_FITBIT_TOKEN_REQUEST = 'UPDATE_FITBIT_TOKEN_REQUEST'
export const UPDATE_FITBIT_TOKEN_SUCCESS = 'UPDATE_FITBIT_TOKEN_SUCCESS'
export const UPDATE_FITBIT_TOKEN_FAIL = 'UPDATE_FITBIT_TOKEN_FAIL'
export const UPDATE_FITBIT_TOKEN_RESET = 'UPDATE_FITBIT_TOKEN_RESET'

export const GET_FITBIT_SLEEP_LOG_REQUEST = 'GET_FITBIT_SLEEP_LOG_REQUEST'
export const GET_FITBIT_SLEEP_LOG_SUCCESS = 'GET_FITBIT_SLEEP_LOG_SUCCESS'
export const GET_FITBIT_SLEEP_LOG_FAIL = 'GET_FITBIT_SLEEP_LOG_FAIL'
export const GET_FITBIT_SLEEP_LOG_RESET = 'GET_FITBIT_SLEEP_LOG_RESET'

export const CONNECT_AMI_DEVICE_REQUEST = 'CONNECT_AMI_DEVICE_REQUEST'
export const CONNECT_AMI_DEVICE_SUCCESS = 'CONNECT_AMI_DEVICE_SUCCESS'
export const CONNECT_AMI_DEVICE_FAIL = 'CONNECT_AMI_DEVICE_FAIL'
export const CONNECT_AMI_DEVICE_RESET = 'CONNECT_AMI_DEVICE_RESET'

export const UNLINK_AMI_DEVICE_REQUEST = 'UNLINK_AMI_DEVICE_REQUEST'
export const UNLINK_AMI_DEVICE_SUCCESS = 'UNLINK_AMI_DEVICE_SUCCESS'
export const UNLINK_AMI_DEVICE_FAIL = 'UNLINK_AMI_DEVICE_FAIL'

export const CREATE_JITAI_TASKS_REQUEST = 'CREATE_JITAI_TASKS_REQUEST'
export const CREATE_JITAI_TASKS_SUCCESS = 'CREATE_JITAI_TASKS_SUCCESS'
export const CREATE_JITAI_TASKS_FAIL = 'CREATE_JITAI_TASKS_FAIL'
export const CREATE_JITAI_TASKS_RESET = 'CREATE_JITAI_TASKS_RESET'

export const REFRESH_JITAI_TASKS_REQUEST = 'REFRESH_JITAI_TASKS_REQUEST'
export const REFRESH_JITAI_TASKS_SUCCESS = 'REFRESH_JITAI_TASKS_SUCCESS'
export const REFRESH_JITAI_TASKS_FAIL = 'REFRESH_JITAI_TASKS_FAIL'
export const REFRESH_JITAI_TASKS_RESET = 'REFRESH_JITAI_TASKS_RESET'

export const SAVE_JITAI_DATA_RESP_REQUEST = 'SAVE_JITAI_DATA_RESP_REQUEST'
export const SAVE_JITAI_DATA_RESP_SUCCESS = 'SAVE_JITAI_DATA_RESP_SUCCESS'
export const SAVE_JITAI_DATA_RESP_FAIL = 'SAVE_JITAI_DATA_RESP_FAIL'
export const SAVE_JITAI_DATA_RESP_RESET = 'SAVE_JITAI_DATA_RESP_RESET'

export const GET_JITAI_DATA_RESP_REQUEST = 'GET_JITAI_DATA_RESP_REQUEST'
export const GET_JITAI_DATA_RESP_SUCCESS = 'GET_JITAI_DATA_RESP_SUCCESS'
export const GET_JITAI_DATA_RESP_FAIL = 'GET_JITAI_DATA_RESP_FAIL'
export const GET_JITAI_DATA_RESP_RESET = 'GET_JITAI_DATA_RESP_RESET'
